import React from 'react';

import { Container, Image } from './UserThumbnail.styles';

export interface UserThumbnailProps {
  src: string;
}

function UserThumbnail({ src }: UserThumbnailProps) {
  return (
    <Container>
      <Image src={src} />
    </Container>
  );
}

export default UserThumbnail;
